angular.module('dpw.services')
    .factory('dpwToastService', ['$rootScope', 'popup',
        function ($rootScope, popup) {
            return {
                showToast: showToast
            };

            function showToast(content, options) {
                var newScope = $rootScope.$new();
                newScope.config = _.extend({
                    content: content,
                    close: function () {
                        newScope.$destroy();
                    },
                    disappearTime: options && options.disappearTime
                });

                popup({
                    scope: newScope,
                    directiveName: 'dpw-toast',
                    extraClass: (options && options.extraClass) || 'dpw-toast-container',
                    showCloseBtn: (options && options.showCloseBtn) || 'false'
                });
            }
        }]);
